import { render, staticRenderFns } from "./TravelDetail.vue?vue&type=template&id=acbb9348&scoped=true"
import script from "./TravelDetail.vue?vue&type=script&lang=js"
export * from "./TravelDetail.vue?vue&type=script&lang=js"
import style0 from "./TravelDetail.vue?vue&type=style&index=0&id=acbb9348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbb9348",
  null
  
)

export default component.exports